export const protocolsPET = ["Здесь будут протоколы пэт"];
